import React from 'react';
import { BREAKPOINT } from '@latitude/core/utils/constants';
import { ConfettiFramedContainer } from '@latitude/confetti-framed-container';
import EstimateRateWidget from './EstimateRateWidget';

export const EstimateRateWidgetSection = props => {
  return (
    <div
      id="check-your-rate"
      css={`
        position: relative;
        z-index: 1;
        & > div {
          @media (max-width: ${BREAKPOINT.LG}) {
            padding: 16px 16px 0;
            margin-bottom: -26px;
          }
          @media (min-width: ${BREAKPOINT.LG}) {
            padding-bottom: 38px;
          }
        }
      `}
    >
      <ConfettiFramedContainer>
        <EstimateRateWidget
          values={{ purpose: props?.purpose }}
          parentOnChangeEvent={ props?.parentOnChangeEvent }
          main
          isBetterStart={!!props.isBetterStart}
        />
      </ConfettiFramedContainer>
    </div>
  );
};
